import React, { useEffect } from 'react';
import styled from 'styled-components';

const Alert = ({ msg, type, removeAlert }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      removeAlert();
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [removeAlert]);

  return (
    <AlertPageStyled>
      <div className={`alert alert-${type}`}>
        <h3 className="alert-title">{msg}</h3>
      </div>
    </AlertPageStyled>
  );
};

const AlertPageStyled = styled.section`
  position: fixed;
  top: 10%;
  left: 34%;
  transition: all 0.3s ease-in-out;

  .alert {
    margin-bottom: 1rem;
    width: 512px;
    padding: 16px;
    margin: 8px;
    display: grid;
    align-items: center;
    text-align: center;
    font-size: 0.7rem;
    border-radius: 0.25rem;
    letter-spacing: var(--spacing);
    text-transform: capitalize;
    .alert-title {
      margin-top: 0;
      font-size: 18px;
    }
  }
  .alert-danger {
    border-left: 4px solid #ff3838;
    border-right: 4px solid #ff3838;
    background-color: rgba(46, 201, 70, 0.5);
    color: var(--white-color);
  }
  .alert-success {
    border-left: 4px solid var(--primary-color);
    border-right: 4px solid var(--primary-color);
    background-color: rgba(46, 201, 70, 0.5);
    color: var(--white-color);
  }
`;

export default Alert;
